// extracted by mini-css-extract-plugin
module.exports = {"link":"OfferRequirements_link__HQuzJ","root":"OfferRequirements_root__fG_5I","divider":"OfferRequirements_divider___KxH6","check":"OfferRequirements_check__JI118"};